import {
  isIntegerNumeric,
  isNotCompleteFloatNumeric,
  isNotCompleteIntegerNumeric,
  isNumeric,
  isNumericWithInsignificantZeros,
  isSemiCompleteFloatNumeric,
  OR,
} from '@library/utils'
import type { Primitives } from 'common/types'

export type NumericMode = 'integer' | 'float'
type Validator = (value: string) => boolean
type ModeValidator = {
  isComplete: Validator
  isInProgress: Validator
}

export const MODE_VALIDATORS: Record<NumericMode, ModeValidator> = {
  float: {
    isInProgress: OR(isSemiCompleteFloatNumeric, isNotCompleteFloatNumeric),
    isComplete: isNumeric,
  },
  integer: {
    isInProgress: isNotCompleteIntegerNumeric,
    isComplete: isIntegerNumeric,
  },
}

export function isSyncingSignificantZeros(
  externalValue: Primitives,
  prevValue: Primitives,
): boolean {
  return !(
    prevValue &&
    isNumericWithInsignificantZeros(prevValue.toString()) &&
    externalValue === '0'
  )
}
